export class SessionStat {
  acctinputoctets;
  acctoutputoctets;
  acctsessionid;
  acctsessiontime;
  acctstartdelay;
  acctstarttime;
  acctstopdelay;
  acctstoptime;
  acctterminatecause;
  acctuniqueid;
  calledstationid;
  callingstationid;
  clientId;
  framedipaddress;
  lastUpdate;
  loginType = {
    userType: '',
  };
  nasid;
  nasipaddress;
  nasportid;
  nasporttype;
  radiusSessionsId;
  username;
  wisprlocationid;
  wisprlocationname;

  constructor(obj?: SessionStat) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/sessions/sessions-stat/sessions-stat.model.ts